import { createGlobalStyle } from 'styled-components';
import { TextColor } from './colorSemantic';

export const palette = {
    white: '#ffffff',
    gray: '#666666',
    blue: '#1C0AED',
    black: '#000000',
    warning: '#ff0000',
    testGray: '#cccccc',
    lightGray: '#f5f5f5',
    textInfo: '#AAAAAA',
    primary: '#264C97',
    primaryNormal: '#F0F6FF',
    backgroundNormal: '#F4F4F5',
    borderNormal: '#DBDCDF',
    accentCyan: '#00C0DA',
    textNeutral: '#333333',
    textNormal: '#101010',
    textWeak: '#999999',
    primaryNormalOpacity: 'rgba(64, 108, 197, 0.08)',
    cyanOpacity: 'rgba(0, 192, 218, 0.08)',
    floatingBlack: 'rgba(0, 0, 0, 0.35)',
};

export const font = {
    size: {
        52: '52px',
        40: '40px',
        32: '32px',
        28: '28px',
        24: '24px',
        22: '22px',
        20: '20px',
        18: '18px',
        17: '17px',
        16: '16px',
        15: '15px',
        14: '14px',
        13: '13px',
        12: '12px',
        10: '10px',
    },
    weight: {
        bold: 700,
        semiBold: 600,
        medium: 500,
        regular: 400,
        semiLight: 300,
        light: 200,
    },
};

export const zIndex = {
    basic: 1,
    dropdown: 2,
    floating: 3,
    sideBar: 4,
    dim: 5,
    sidebar: 6,
    modalPopup: 10,
    toast: 20,
    loading: 100,
};

export const GlobalStyles = createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    user-select: none;
    -webkit-tap-highlight-color: transparent;
    -webkit-touch-callout: none;
    font-family: Pretendard;
  }

html, body, div, span, applet, object, iframe,
h1, h2, h3, h4, h5, h6, p, blockquote, pre,
a, abbr, acronym, address, big, cite, code,
del, dfn, em, img, ins, kbd, q, s, samp,
small, strike, strong, sub, sup, tt, var,
b, u, i, center,
dl, dt, dd, ol, ul, li,
fieldset, form, label, legend,
table, caption, tbody, tfoot, thead, tr, th, td,
article, aside, canvas, details, embed, 
figure, figcaption, footer, header, hgroup, 
menu, nav, output, ruby, section, summary,
time, mark, audio, video {
	margin: 0;
	padding: 0;
	border: 0;
	font-size: 100%;
  font: inherit;
	font-family: Pretendard;
	vertical-align: baseline;
}

/* HTML5 display-role reset for older browsers */
article, aside, details, figcaption, figure, 
footer, header, hgroup, menu, nav, section {
	display: block;
}

html, body {
  -ms-overflow-style: none; /* IE, Edge */
  scrollbar-width: none; /* Firefox */
  overflow: -moz-scrollbars-none; /* Old Firefox */
  overflow-y: scroll; /* Enable scrolling */
  color: ${TextColor.color_text_normal};
}

/* Hide scrollbar for Chrome, Safari, and Opera */
html::-webkit-scrollbar, body::-webkit-scrollbar {
  display: none;
}

ol, ul {
	list-style: none;
}
blockquote, q {
	quotes: none;
}
blockquote:before, blockquote:after,
q:before, q:after {
	content: '';
	content: none;
}
table {
	border-collapse: collapse;
	border-spacing: 0;
}
button {
	cursor: pointer;
  border: none;
  margin: 0;
  padding: 0;
  width: auto;
  height: auto;
  overflow: visible;
  background: transparent;
  color: inherit;
  font: inherit;
  line-height: normal;
  -webkit-font-smoothing: inherit;
  -moz-osx-font-smoothing: inherit;
  -webkit-appearance: none;
  font-family: Pretendard;
}

input, textarea, select {
  font-family: Pretendard;
}

input:focus {
	outline: none;
}

@media print {
  @page {
    size: A4;
    margin: 0;
  }
}
  `;
